export function buildCoachHealthScopeKey(authenticatedCoachId: string): string {
  return `coach:${authenticatedCoachId}`;
}

export function coachHealthProfileQueryKey(authenticatedCoachId: string) {
  return [
    "coach-health-evidence-profile-v2",
    buildCoachHealthScopeKey(authenticatedCoachId),
  ] as const;
}
